import React, { useEffect, useRef, useState } from 'react'
import AppPopover from '../../../../UIComponents/ModalShell/AppPopover'
import { useDispatch, useSelector } from 'react-redux'

import OptionButton from './OptionButton'
import PreConfigTaskGeneratorModal from '../../../../UIComponents/FloatModals/PreConfigTaskGeneratorModal/PreConfigTaskGeneratorModal'
import RunOutOfGoldAssistantModal from '../../../../ChatsView/ChatDV/EditorView/BotOption/RunOutOfGoldAssistantModal'
import { hideFloatPopup, showFloatPopup } from '../../../../../redux/actions'
import { isModalOpen, MENTION_MODAL_ID } from '../../../../ModalsManager/modalsManager'

export default function OptionButtonWrapper({ projectId, containerStyle, text, icon, task, assistant }) {
    const dispatch = useDispatch()
    const gold = useSelector(state => state.loggedUser.gold)
    const isExecuting = useSelector(state => state.preConfigTaskExecuting)
    const [isOpen, setIsOpen] = useState(false)
    const isUnmountedRef = useRef(false)

    useEffect(() => {
        return () => {
            isUnmountedRef.current = true
        }
    }, [])

    const safeSetIsOpen = value => {
        if (!isUnmountedRef.current) {
            setIsOpen(value)
        }
    }

    const openModal = () => {
        safeSetIsOpen(true)
        dispatch(showFloatPopup())
    }

    const closeModal = () => {
        if (isModalOpen(MENTION_MODAL_ID)) return
        safeSetIsOpen(false)
        dispatch(hideFloatPopup())
    }

    return (
        <>
            {isOpen ? (
                <AppPopover
                    content={
                        gold > 0 ? (
                            <PreConfigTaskGeneratorModal
                                projectId={projectId}
                                closeModal={closeModal}
                                task={task}
                                assistant={assistant}
                            />
                        ) : (
                            <RunOutOfGoldAssistantModal closeModal={closeModal} />
                        )
                    }
                    align={'start'}
                    position={['bottom', 'left', 'right', 'top']}
                    onClickOutside={closeModal}
                    isOpen
                    contentLocation={null}
                    disableReposition
                >
                    <OptionButton
                        text={text}
                        icon={icon}
                        containerStyle={containerStyle}
                        onPress={openModal}
                        disabled={isExecuting === task?.name}
                    />
                </AppPopover>
            ) : (
                <OptionButton
                    text={text}
                    icon={icon}
                    containerStyle={containerStyle}
                    onPress={openModal}
                    disabled={isExecuting === task?.name}
                />
            )}
        </>
    )
}
